/**
 * 加载屏。两种用法：
 *  1) 直接传 progress 数字。
 *  2) 在 R3F Suspense fallback 中作为子组件，自动连接 drei useProgress。
 */
import { useProgress } from '@react-three/drei'

export function LoadingScreen({ progress }: { progress?: number }) {
  // 仅当未显式提供 progress 时，才订阅 drei 的全局 loading store。
  const tracked = useProgress((s) => s.progress)
  const value = progress ?? tracked
  return (
    <div
      role="status"
      aria-label="loading"
      style={{
        position: 'absolute',
        inset: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#02060a',
        color: '#9cf',
        fontFamily: 'system-ui, sans-serif',
        gap: 12,
        zIndex: 20,
      }}
    >
      <div style={{ fontSize: 18, opacity: 0.85 }}>加载中… {Math.round(value)}%</div>
      <div
        style={{
          width: 280,
          height: 4,
          background: 'rgba(255,255,255,0.12)',
          borderRadius: 2,
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            width: `${Math.max(0, Math.min(100, value))}%`,
            height: '100%',
            background: '#4cd1ff',
            transition: 'width 0.2s ease',
          }}
        />
      </div>
    </div>
  )
}

